import { Profile } from 'app/types';

export function isPregnant(profile: Profile) {
  return profile.pregStatus === 'YES';
}
